import React from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import { RedLiveIcon } from '@src/components/common/icons/RedLiveIcon';

const StyledTagContent = styled.div`
	color: #333333;
	display: flex;
	align-items: center;
	font-size: 12px;
	& > svg {
		margin-right: 4px;
	}
`;

const MobileTagContent = (): JSX.Element => {
	const { t } = useTranslation();

	return (
		<StyledTagContent>
			<RedLiveIcon />
			<span>{t('training:course:webinar:webinar')}</span>
		</StyledTagContent>
	);
};

export default MobileTagContent;
